import {useEffect} from 'react';
import Checkbox from '@/Components/Checkbox';
import GuestLayout from '@/Layouts/GuestLayout';
import InputError from '@/Components/InputError';
import {Label} from '@/Components/ui/label.jsx';
import PrimaryButton from '@/Components/PrimaryButton';
import TextInput from '@/Components/TextInput';
import {Head, Link, useForm} from '@inertiajs/react';
import GuestHeader from "@/Components/GuestHeader.jsx";
import {Button} from "@/Components/ui/button";

export default function Login({ status, canResetPassword}) {

    const {data, setData, post, processing, errors, reset} = useForm({
        company_name: '',
        email: '',
        password: '',
        remember: false,
    });

    useEffect(() => {
        return () => {
            reset('password');
        };
    }, []);

    const submit = (e) => {
        e.preventDefault();
        post(`login`, {
            preserveScroll: true,
            onSuccess: () => {
                reset('password');
            },
            onError: () => {
                console.log('error')
            }
        });
    };

    return (
        <GuestLayout>
            <Head title={`Log in`}/>

            <GuestHeader
                className="text-center"
                header="Log in to your account"
                subheader="Welcome back! Please enter your details."
            />
            <div className="sm:max-w-md w-full mt-4">

                    {status && <div className="mb-4 font-medium text-sm text-green-600">{status}</div>}

                    <form onSubmit={submit}>

                        <div className="mt-4">
                            <Label htmlFor="email" value="Email"/>

                            <TextInput
                                id="email"
                                type="email"
                                name="email"
                                value={data.email}
                                className="mt-1 block w-full"
                                autoComplete="username"
                                isFocused={true}
                                onChange={(e) => setData('email', e.target.value)}
                            />

                            <InputError message={errors.email} className="mt-2"/>
                        </div>

                        <div className="mt-4">
                            <Label htmlFor="password" value="Password"/>

                            <TextInput
                                id="password"
                                type="password"
                                name="password"
                                value={data.password}
                                className="mt-1 block w-full"
                                autoComplete="current-password"
                                onChange={(e) => setData('password', e.target.value)}
                            />

                            <InputError message={errors.password} className="mt-2"/>
                        </div>

                        <div className="flex justify-between mt-4">
                            <label className="flex items-center">
                                <Checkbox
                                    name="remember"
                                    checked={data.remember}
                                    onChange={(e) => setData('remember', e.target.checked)}
                                />
                                <span className="ms-2 text-sm text-gray-600">Remember me</span>
                            </label>
                            {canResetPassword && (
                                <Link
                                    href={route('password.request', {region: data.region})}
                                    className="underline text-sm text-violet-900 hover:text-violet-900 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                                >
                                    Forgot your password?
                                </Link>
                            )}

                        </div>

                        <div className="flex w-full mt-4">

                            <Button size="lg" className="ms-auto w-full" type="submit" disabled={processing}>
                                Login
                            </Button>

                        </div>
                    </form>

                    {/* A link that allows users to go to the registration page */}

                    <div className="flex items-center justify-center mt-4">
                        <Link href={route('pricing')}
                              className="text-sm text-gray-600 hover:underline hover:text-gray-900 rounded focus:outline-none focus:ring-2 focus:ring-violet-500">
                            Don't have an account? Register here.
                        </Link>
                    </div>
                </div>
        </GuestLayout>
);
}
